export default __webpack_public_path__ + "static/media/olympic-bake-off-medal-gold.d039c5f3.svg";